import React from 'react';
import styles from './StatusBadge.module.scss';

interface StatusBadgeProps {
  status: 'pendiente' | 'aprobado' | 'rechazado' | 'pending' | 'approved' | 'refused' | boolean | null | string;
  type?: 'identity' | 'project';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type = 'project' }) => {
  const getStatusConfig = () => {
    if (type === 'identity') {
      if (status === true) {
        return { text: 'Verificado', className: styles.approved };
      } else if (status === false) {
        return { text: 'Rechazado', className: styles.rejected };
      } else {
        return { text: 'Pendiente', className: styles.pending };
      }
    }

    switch (status) {
      case 'aprobado':
      case 'approved':
        return { text: 'Aprobado', className: styles.approved };
      case 'rechazado':
      case 'refused':
        return { text: 'Rechazado', className: styles.rejected };
      case 'pendiente':
      case 'pending':
        return { text: 'Pendiente', className: styles.pending };
      case '':
      case null:
      case undefined:
        return { text: 'Sin estado', className: styles.noState };
      default:
        return { text: 'Sin estado', className: styles.noState };
    }
  };

  const config = getStatusConfig();

  return (
    <span className={`${styles.badge} ${config.className}`}>
      {config.text}
    </span>
  );
};

export default StatusBadge;

